<div class="breadcrumb-bar">
    <app-breadcrumb></app-breadcrumb>
</div>
<div class="main">
    <div class="container" >
        <div class="container-flight-detail" >
            <div class=details-col >
                <div class="map-container box-shadow">
                    <div id="seqMap" [class.dark-theme]="theme$ === 'dark'">
                        <button class="map-reset-btn" (click)="onResetMap()">
                            <i class="pi pi-refresh"></i>
                        </button>
                    </div>
                </div>
                <div *ngIf="sequence$ | async as sequence">
                    @if (!sequence.isLoading && !sequence.response) {
                        <div class="no-sequence-found">Sequence Not Found</div>
                    }
                    @if (sequence.response) {
                        <div class="col">
                            <div class="header">
                                <div class="tag sequence box-shadow">{{sequence.response.sequenceNumber}}</div>
                                @if (sequence.response.addReasonCode && validateReasonCode(sequence.response.addReasonCode)) {
                                    <div class="tag oal-surface box-shadow" (click)="op.toggle($event)">
                                        {{validateReasonCode(sequence.response.addReasonCode)}}</div>
                                }
                            </div>
                            <app-data-box class="data-box" headerTitle="Sequence Totals" [dataBoxItems]="loadDataBox(sequence.response)"
                                [helpComponent]="sequenceTotalsInfoDialog">
                            </app-data-box>
                        </div>
                        <!-- !Toolbar added TBD -->
                        <!-- <app-flights-toolbar [lastUpdated]="lastUpdated"></app-flights-toolbar> -->
                        <div class="flight-list-col">
                            <div class="duty-container"
                                *ngFor="let duty of sequence.response.dutyPeriodSummaries; index as i; last as isLast">
                                <div class="flight-list-row">
                                    <div class="col border box-shadow">
                                        @if(getLayover(duty)) {
                                        <div class="duty-totals-layover">
                                            <div class="duty-content">
                                                <div class="duty-title" *ngFor="let item of dutyBoxItems(duty); let i = index;"
                                                    [class.left-divider-1]="i > 0">
                                                    {{item.value}}
                                                    <div class="item-label">{{item.label}}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div [ngClass]="{'divider-dark-theme': theme$ === 'dark'}">
                                            <hr class="divider"/>
                                        </div>
                                        <div class="layover">
        
                                            <div class="layover-content left">
                                                <span class="item-label">Layover</span>
                                                <span class="length">{{ getLayover(duty)?.station}}</span>
                                            </div>
                                            <div class="layover-content">
                                                <span class="item-label">ODL</span>
                                                <span class="length">{{ getLayover(duty)?.length }}</span>
                                            </div>
                                            <div class="layover-content right">
                                                <div class="help-icon pi pi-question-circle" (click)="onDutyHelpClicked()">
                                                </div>
                                            </div>
                                        </div>
                                        }
                                        @else {<div class="duty-totals">
                                            <div class="duty-content">
                                                <div class="duty-title" *ngFor="let item of dutyBoxItems(duty); let i = index;"
                                                    [class.left-divider-1]="i > 0">
                                                    {{item.value}}
                                                    <div class="item-label">{{item.label}}</div>
                                                </div>
                                            </div>
                                        </div>}
                                        <div class="flt-item-detail"
                                            [style]="theme$ === 'light' ? 
                                            {'background': 'var(--p-surface-0)'} : {'background': 'var(--p-surface-50)'}"
                                            *ngFor="let leg of duty.legs; last as isLast; first as isFirst"
                                            [ngClass]="{'flt-item': !isLast, 'flt-item last': isLast}">
                                            <app-flight-item (click)="onLegClicked(leg, sequence.response)"
                                                [isTimeFormatUTC]="isTimeFormatUTC"
                                                [flightNumber]="leg.flightNumber" [aircraft]="leg.aircraft"
                                                [depStation]="leg.departureStation.code" [arrStation]="leg.arrivalStation.code"
                                                [depTimes]="leg.departure" [arrTimes]="leg.arrival"
                                                [flightTimeActual]="leg.flightTimeActual" [isDeadhead]="leg.isDeadhead"
                                                [isCancelled]="leg.isCancelled">
                                            </app-flight-item>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>
</div>
<p-popover #op>
        <div class="col">
            <div class="title-overlay">
                Add Reason Code
            </div>
            <div class="row">
                <div class="code">
                    {{validateReasonCode(addReasonCode || '')}}:
                </div>
                <div class="reason-code-description">
                    {{reasonCodes[validateReasonCode(addReasonCode || '') || '']}}
                </div>
            </div>
        </div>
</p-popover>
<!-- <p-dialog  header="Sequence" [modal]="true">
    <div class="container-content">
        <div class="col">
            <div class="dialog">Sequence Not Found.</div>
            <button class="close-btn" (click)="onClose()">Close</button>
        </div>
    </div>
</p-dialog>
<ng-template>
</ng-template> -->